import { useEffect, useMemo, useState } from "react";
import { message } from "antd";
import { R_EVENTS } from "../../../../../constants/routes";
import { ADMIN_EVENTS } from "../../../../../constants/api";
import { EVENT_TYPE_OPTIONS } from "../../constants";
import { eventApi } from "../../utils/eventApi";
import { getEventStartDateValue } from "../../utils/eventFormatters";
import { showEventApiError } from "../../utils/eventMessages";
import {
  createEventPayload,
  createUpdateEventPayload,
  getFormValuesFromEvent,
  getDateValue,
  hasEventStarted,
} from "../utils/eventFormValues";

const createEvent = async (values) =>
  eventApi.post(ADMIN_EVENTS, createEventPayload(values));

const updateEvent = async (values, event) =>
  eventApi.put(ADMIN_EVENTS, createUpdateEventPayload(values, event));

export const useEditEventForm = ({ form, event, isCreateMode, history }) => {
  const [isSaving, setIsSaving] = useState(false);

  const eventTypeOptions = EVENT_TYPE_OPTIONS;
  const eventStarted = useMemo(
    () =>
      !isCreateMode &&
      hasEventStarted(getDateValue(getEventStartDateValue(event))),
    [event, isCreateMode],
  );

  const handleCancel = () => {
    history.push(R_EVENTS);
  };

  const handleFinish = async (values) => {
    if (isCreateMode) {
      try {
        setIsSaving(true);
        await createEvent(values);
        message.success("Evento criado com sucesso.");
        history.push(R_EVENTS);
      } catch (error) {
        showEventApiError(
          error,
          "Não foi possível criar o evento.",
          "Erro ao criar Evento: "
        );
      } finally {
        setIsSaving(false);
      }

      return;
    }

    if (!event) {
      history.push(R_EVENTS);
      return;
    }

    try {
      setIsSaving(true);
      await updateEvent(values, event);
      message.success("Evento atualizado com sucesso.");
      history.push(R_EVENTS);
    } catch (error) {
      showEventApiError(
        error,
        "Não foi possível atualizar o evento.",
        "Erro ao atualizar Evento: "
      );
    } finally {
      setIsSaving(false);
    }
  };

  useEffect(() => {
    if (isCreateMode) {
      form.resetFields();
      return;
    }

    form.setFieldsValue(getFormValuesFromEvent(event));
  }, [event, form, isCreateMode]);

  return {
    isSaving,
    eventStarted,
    eventTypeOptions,
    handleFinish,
    handleCancel,
  };
};
